import {
  Config,
  getConfig as getConfigRoot
} from 'msp-integrations'
import { defineMessage } from 'react-intl'

const tenantId = 'default'

const defaultConfig: Partial<Config> = {
  defaultLocale: 'de-DE',
  tenantId,
  cookiePrefix: '',
  phonePREFIX: '+44-',
  API_ERROR_MESSAGE: defineMessage({
    id: 'global.error.something_went_wrong',
    defaultMessage: 'Something went wrong. Please try again later!'
  }),
  theme: {
    // iconMapping: SVGMapping,
    font: {
      regular: 'font-sans'
    },
    fontVariant: {
      regular: 'font-sans'
    },
    mspComponents: {}
  },
  info: {
    email: 'service@darq.com',
    tel: '+49 (0) 800 7000 654',
    organization: 'Melitta Single Portions GmbH & Co. KG',
    logo: 'static/img/logo.png'
  },
  ssr: {
    serviceCloudKeys: {}
  }
}

export const getConfig = (
  config: Partial<Config>,
  ssrConfig?: any
): Config => ({
  ...getConfigRoot(defaultConfig, config),
  ssr: {
    googleMapsAPIKey: ssrConfig?.externalIntegrations?.googleMapsAPIKey,
    serviceCloudKeys: ssrConfig?.serviceCloudKeys
  }
})

export default defaultConfig
